export const getDataLayerEvents = (eventName: string) => {
  // @ts-ignore
  if (typeof window !== 'undefined' && window.dataLayer) {
    // @ts-ignore
    window.dataLayer.push({ event: eventName });
  }
};
